module.exports = __webpack_public_path__ + "static/media/loading_bot.f5a286bb.png";